import type { Conversation } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import { conversationQueryKeys } from './conversation-query-keys';

const fetchConversationDetails = async (conversationId: string): Promise<Conversation> => {
  const response = await api.get(`/dashboard/conversations/${conversationId}`);
  return response.data;
};

export const useConversationDetailsQuery = (
  brandId: string | null | undefined,
  conversationId: string
) => {
  return useQuery<Conversation, Error>({
    queryKey: conversationQueryKeys.detail(brandId ?? '', conversationId),
    queryFn: () => fetchConversationDetails(conversationId),
    enabled: !!brandId && !!conversationId,
    gcTime: 1000 * 60 * 5, // 5 minutes
    staleTime: 1000 * 60, // 1 minute
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
